import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {wrapActionCreator} from '../../../../helpers/reduxHelpers';
import {Dispatch} from '../../../../store/appStore';
import {toggleLastSuppressionListsRemovalAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getLastSuppressionListsRemoval} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {SuppressionListsRemovalBanner} from './suppressionListsRemovalBanner';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  unsuppressedEmailAddress: getLastSuppressionListsRemoval,
}));

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    toggleLastSuppressionListsRemoval: wrapActionCreator(dispatch, toggleLastSuppressionListsRemovalAction),
  };
}

export const SuppressionListsRemovalBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, _ownProps) => ({
    ...stateProps,
    onDismissClick: () => {
      if (!stateProps.unsuppressedEmailAddress) {
        return;
      }

      dispatchProps.toggleLastSuppressionListsRemoval(stateProps.unsuppressedEmailAddress, true);
    },
  }),
)(SuppressionListsRemovalBanner);
